"use client";

import { FlaskConical } from "lucide-react";

export default function Loading() {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background">
      {/* Background Decorative Elements (Subtle) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[10%] -left-[10%] h-[40%] w-[40%] animate-pulse rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute -right-[10%] -bottom-[10%] h-[40%] w-[40%] animate-pulse rounded-full bg-primary/5 blur-[120px]" />
      </div>

      <div className="relative flex flex-col items-center gap-6">
        {/* Animated Logo Container */}
        <div className="relative group">
          {/* Outer Glow */}
          <div className="absolute inset-0 animate-ping rounded-lg bg-primary/20 opacity-75 blur-xl" />
          
          {/* Main Icon Box */}
          <div className="relative flex h-20 w-20 animate-bounce items-center justify-center rounded-lg bg-primary shadow-2xl shadow-primary/30 transition-transform duration-500 ease-in-out group-hover:scale-110">
            <FlaskConical className="h-10 w-10 text-primary-foreground" />
          </div>

          {/* Orbiting dots for extra premium feel */}
          <div className="absolute -inset-4 animate-[spin_3s_linear_infinite] rounded-full border border-dashed border-primary/20" />
        </div>

        {/* Text Section */}
        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-xl font-bold tracking-tight text-foreground">
            Smoke Analysis
          </h2>
          <div className="flex items-center gap-1.5">
            <div className="flex gap-1">
              <span className="h-1 w-1 animate-bounce rounded-full bg-muted-foreground/40 [animation-delay:-0.3s]" />
              <span className="h-1 w-1 animate-bounce rounded-full bg-muted-foreground/40 [animation-delay:-0.15s]" />
              <span className="h-1 w-1 animate-bounce rounded-full bg-muted-foreground/40" />
            </div>
            <p className="text-sm font-medium text-muted-foreground">
              Preparing your workspace
            </p>
          </div>
        </div>

        {/* Progress bar line (Indeterminate) */}
        <div className="mt-4 h-1 w-48 overflow-hidden rounded-full bg-muted">
          <div className="h-full w-full origin-left animate-loading-progress bg-primary" />
        </div>
      </div>
    </div>
  );
}
